module.exports = __webpack_public_path__ + "img/no-logo.4f6ddfa7.jpg";